_ = require 'underscore'
Auth = require 'db/auth'
Card = require 'models/card'
Controller = require 'controller'
Board = require 'models/board'
List = require 'models/list'
Member = require 'models/member'
Plugin = require 'models/plugin'
Promise = require 'bluebird'
makeErrorEnum = require 'lib/make-error-enum'
ModelCache = require 'db/model-cache'
xtend = require 'xtend'

PluginHandlerContextError = makeErrorEnum 'PluginHandlerContext', [
  'InvalidSignature'
  'InvalidType'
  'NotSerializable'
]

elMap = {}

isCurrentBoard = (idBoard) ->
  (board = Controller.getCurrentBoard())? && board.id == idBoard

alphabet = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWYXZ"

randomId = (length = 16) ->
  digits = []
  for i in [0...length]
    digits.push(alphabet[Math.floor(Math.random() * alphabet.length)])
  digits.join('')

handlers = {}

# We have to be able to convert a context object into something we can send
# over postMessage; there are a few special keys that contain complex objects
# that we know how to serialize
converters =
  card:
    type: Card
    serialize: (card) ->
      value: card.id
    deserialize: (idCard) ->
      requestedCard = ModelCache.get('Card', idCard)
      if requestedCard? && isCurrentBoard(requestedCard.get('idBoard'))
        requestedCard
      else
        null

  board:
    type: Board
    serialize: (board) ->
      value: board.id
    deserialize: (idBoard) ->
      if isCurrentBoard(idBoard)
        ModelCache.get('Board', idBoard)
      else
        null

  list:
    type: List
    serialize: (list) ->
      value: list.id
    deserialize: (idList) ->
      requestedList = ModelCache.get('List', idList)
      if requestedList? && isCurrentBoard(requestedList.get('idBoard'))
        requestedList
      else
        null

  member:
    type: Member
    serialize: (member) ->
      value: member.id
    deserialize: (idMember) ->
      if Auth.isMe(idMember)
        ModelCache.get('Member', idMember)
      else
        null

  el:
    type: Element
    serialize: (element) ->
      ref = randomId()
      elMap[ref] = element

      value: ref
      disposer: ->
        delete elMap[ref]
    deserialize: (ref) ->
      elMap[ref]

SIGNATURE_KEY = '__insecure_signature'
HASH_SECRET = randomId(64)

# Intended to work on objects that are just key:string pairs, so the sorting
# only happens at the top level
generateSignature = (simpleObj) ->
  normalized = _.chain(simpleObj)
  .pairs()
  .sortBy ([key, value]) -> key
  .filter ([key]) -> key != SIGNATURE_KEY
  .object()
  .value()

  # This is *not* meant to be a secure hashing function; this is just intended
  # to discourage developers from trying to modify the context.  We still
  # should be suspicious of any information coming back to us in the context;
  # we're only using a signing approach so we don't have to keep a reference
  # to every context we've ever sent
  [
    HASH_SECRET
    JSON.stringify(normalized)
    HASH_SECRET
  ]
  .join('\n')
  .split('')
  .reduce((acc, c) ->
    acc.map (entry) -> (entry * 31 + c.charCodeAt(0)) & 0xffffffff
  , [0, 1, 2, 3])
  .map (num) -> ('00000000' + num.toString(16)).substr(-8, 8)
  .join('')

sign = (simpleObj) ->
  simpleObj[SIGNATURE_KEY] = generateSignature(simpleObj)
  simpleObj

checkSignature = (simpleObj) ->
  generateSignature(simpleObj) == simpleObj[SIGNATURE_KEY]

isSerializable = (obj) ->
  if _.isString(obj) || _.isNumber(obj) || _.isBoolean(obj) || _.isNull(obj) || _.isUndefined(obj)
    true
  else if _.isFunction(obj) || _.isRegExp(obj) || _.isDate(obj)
    false
  else if _.isArray(obj)
    _.every obj, isSerializable
  else if _.isObject(obj)
    isSerializable _.values(obj)
  else
    false

serialize = (context) ->
  disposers = []

  Promise.try ->
    sign _.mapObject context, (value, key) ->
      if (converter = converters[key])?
        if !(value instanceof converter.type)
          if !value?
            return null

          throw PluginHandlerContextError.InvalidType("value in context did not have the expected type")

        { value: serialized, disposer } = converter.serialize(value)
        if disposer?
          disposers.push(disposer)
        serialized
      else if isSerializable(value)
        value
      else
        throw PluginHandlerContextError.NotSerializable("the value for #{ key } was not serializable")
  .disposer ->
    for disposer in disposers
      disposer()
    return

deserialize = (serialized) ->
  # Simple check to prevent naive attempts to modify the context
  if !serialized || !checkSignature(serialized)
    throw PluginHandlerContextError.InvalidSignature('Context signature check failed. This usually means that the Power-Up modified the context between calls to Trello.')

  _.mapObject serialized, (value, key) ->
    if value? && converters.hasOwnProperty(key) && (converter = converters[key])?
      converter.deserialize(value)
    else
      value

extend = (contexts...) ->
  sign(xtend(contexts...))

module.exports =
  Error: PluginHandlerContextError
  serialize: serialize
  deserialize: deserialize
  extend: extend



// WEBPACK FOOTER //
// ./app/scripts/views/internal/plugins/plugin-handler-context.coffee